import React, { useContext } from 'react';
import {
  TabbedContent,
  TabItem,
  Tabs,
  TabsAlignment,
  TabsSkin,
} from '@wix/wix-ui-tpa/cssVars';
import { st, classes } from '../../Widget.st.css';
import { AppContext } from '../../SettingsProvider/SettingsProvider';
import { DATA_HOOKS } from '../../../../../constants/dataHooksElements';

export interface HorizontalCategoriesProps {
  categoriesToRender: TabItem[];
  adjustedActiveTab: number;
  setActiveTab: (index: number) => void;
  splitIntoCategories: boolean;
  rtl: boolean;
}

const HorizontalCategories = ({
  categoriesToRender,
  adjustedActiveTab,
  setActiveTab,
  splitIntoCategories,
  rtl,
}: HorizontalCategoriesProps) => {
  const { searchTerm } = useContext(AppContext);

  return (
    splitIntoCategories &&
    categoriesToRender.length > 0 && (
      <div
        className={st(classes.Tabs, {
          search: !(searchTerm === ''),
        })}
      >
        <TabbedContent
          data-hook={DATA_HOOKS.WIDGET_CATEGORIES_HORIZONTAL}
          items={categoriesToRender.map((item, index) => ({
            id: `${item.id}`,
            title: `${item?.title}`,
            dataHook: `tab-item-${index}`,
          }))}
          activeTabIndex={adjustedActiveTab}
          onTabClick={setActiveTab}
          alignment={rtl ? TabsAlignment.right : TabsAlignment.left}
          skin={TabsSkin.clear}
        >
          {(id) => <></>}
        </TabbedContent>
      </div>
    )
  );
};

export default HorizontalCategories;
